<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="账号名"
                        prop="participant_customer">
            <remote-select class="width-max"
                           v-model="search.intern_user_id"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入账号名搜索"
                           :query-request="queryInternTableApi"
                           :find-request="getInternBaseInfoApi">
            </remote-select>
          </el-form-item>
          <el-form-item label="人员性质"
                        prop="employment_type">
            <el-select v-model="search.employment_type"
                       placeholder="请选择人员性质"
                       class="width-max"
                       clearable>
              <el-option v-for="(label, value) in employmentTypeMap"
                         :key="value"
                         :label="label"
                         :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出勤月份"
                        prop="onduty_month">
            <el-date-picker class="width-max"
                            value-format="yyyy-MM"
                            placeholder="请选择出勤月份"
                            clearable
                            v-model="search.onduty_month"
                            type="month">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否设置日历"
                        prop="fill_attendance_plan">
            <el-select v-model="search.fill_attendance_plan"
                       placeholder="请选择是否设置日历"
                       class="width-max"
                       clearable>
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportMonthlyTable()">
            按条件导出月度统计
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportDailyTable()">
            按条件导出出勤明细
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link to="/audit-intern/attendance-notify-cfg-table">
          <el-button type="primary"
                     icon="el-icon-message-solid"
                     size="small">出勤日历提醒通知
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <template v-for="attr of monthlyTableColumns">
          <el-table-column v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="130">
          <template slot-scope="scope">
            <button-gutter>
              <router-link :to="`/audit-intern/daily-onduty-table?intern_user_id=${scope.row.intern_user_id}&onduty_month=${scope.row.onduty_month}`">
                <el-button type="primary"
                           size="small">
                  查看出勤明细
                </el-button>
              </router-link>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import internOndutyMixins from '@views/audit-intern/intern-onduty.mixins.js'
import RemoteSelect from '@core/components/RemoteSelect.vue'
import ButtonGutter from '@core/components/ButtonGutter.vue'

export default {
  components: {ButtonGutter, RemoteSelect},
  mixins: [table, internOndutyMixins],
  data () {
    return {
      search: {
        intern_user_id: null,
        fill_attendance_plan: null,
        employment_type: null,
        onduty_month: null,
      },
      searchFieldType: {
        intern_user_id: Number,
        fill_attendance_plan: Number,
      },
    }
  },
  computed: {},
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([
      'queryInternTableApi', 'getInternBaseInfoApi', 'queryInternDailyOnDutyTableApi'
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryInternMonthlyOnDutyTableApi', params)
    },
    onExportMonthlyTable () {
      this.$export('导出实习生出勤月度统计', {
        fileHeader: this.monthlyExportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportDailyTable () {
      this.$export('导出实习生出勤明细统计', {
        fileHeader: this.dailyExportHeader,
        total: this.pagination.total,
        request: this.queryInternDailyOnDutyTableApi,
        requestParams: this.search,
      })
    },
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/InternMonthlyOnDutyTable.vue